import {
  withFormsy,
} from 'formsy-react';

import InputCheckboxView from './InputCheckboxView';

// @ts-expect-error form component
const InputComponent = withFormsy(InputCheckboxView);

const Component = InputComponent;

export default Component;
